<template>
<div>
  <!-- <button @click="test">跳转</button> -->
</div>
</template>

<script>
import { sessionStorageUtils } from '@/utils/sessionstorage'
import activityApi from '@/api/activity'
export default {
  data () {
    return {
      key: ''
    }
  },
  mounted () {
    let wxUserInfo = sessionStorageUtils.get('wxUserInfo') || ''
    console.log(wxUserInfo)
    let data = {
      // wxOpenId: 'osI4Xs6hKccVSSPo_xGq63oe-8IM'
      wxOpenId: wxUserInfo.openId || ''
    }
    activityApi.refuelSave(data).then(res => {
      if (res.data.resultCode === '0') {
        this.key = res.data.resultData.requestKey
      }
      this.$router.push({ name: 'activity-refuel-share', query: { key: this.key, user: this.$route.query.user } })
    })
  },
  methods: {
    test () {
      this.$router.push({ name: 'activity-refuel-share', query: { key: this.key, user: this.$route.query.user } })
    }
  }
}
</script>

<style>

</style>
